import { AxiosResponse } from 'axios';
import mixins from 'vue-typed-mixins';

import { ErrorResponse, LoginApi, LoginRequest, ユーザーApi, ユーザーメールアドレスRequest } from '@/openapi/user';

import UserApiUtility from '@/classes/common/UserApiUtility';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import AlertMixin from '@/mixins/AlertMixin';

export default mixins(AlertMixin, RoutesMixin).extend({
  name: 'Login',

  data(): {
    loginRequest: LoginRequest;
    ユーザーメールアドレスRequest: ユーザーメールアドレスRequest;
    passwordReset: {
      dialogVisible: boolean;
    };
  } {
    return {
      loginRequest: {
        cユーザーメールアドレス: '',
        cユーザーパスワード: '',
      },
      ユーザーメールアドレスRequest: {
        cユーザーメールアドレス: '',
      },
      passwordReset: {
        dialogVisible: false,
      },
    };
  },

  methods: {
    async login(): Promise<void> {
      const response = await UserApiUtility.ogApi(LoginApi, false).login(this.loginRequest);
      if (this.isValidationErrorResponse(response)) return;

      this.$router.push(this.routes.事業所List);
    },

    openPasswordReset(): void {
      this.passwordReset.dialogVisible = true;
      this.$_clearResetEmail();
    },

    async sendResetMail(): Promise<void> {
      const response: AxiosResponse<void | ErrorResponse> = await UserApiUtility.ogApi(
        ユーザーApi
      ).sendPasswordResetMail(this.ユーザーメールアドレスRequest);

      if (this.isValidationErrorResponse(response, 'sendPasswordResetEmail.メールアドレスRequest.')) return;
      window.alert('メールを送信しました');
      this.passwordReset.dialogVisible = false;
      this.$_clearResetEmail();
    },

    $_clearResetEmail(): void {
      this.ユーザーメールアドレスRequest.cユーザーメールアドレス = '';
    },
  },
});
